import { GoBackHeaderTitle, If } from "components";
import { t } from "i18next";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";

import { useGetDriverById } from "../../../drivers/apis";
import { DriverActionButtons, DriverInfoContent } from "../../components";
import { DriverDetailsData } from "../../drivers.types";
import { useDriversBasePath } from "../../hooks";

import styles from "./DriverInfo.module.scss";

const DriverInfo = () => {
  const { state: productListSearch } = useLocation();
  const { driverId } = useParams();

  const navigate = useNavigate();
  const basePath = useDriversBasePath();

  const { driver, isLoading } = useGetDriverById(driverId as string);

  const [search] = useState(productListSearch);

  return (
    <ContentLayout
      title={
        <GoBackHeaderTitle
          title={t("Driver Profile")}
          onGoBack={() => navigate({ pathname: basePath, search })}
        />
      }
      action={<DriverActionButtons />}
    >
      <BoxShadowLayout className={styles.productInfo}>
        <If condition={isLoading}>
          <div className={styles.productInfo_loader}>
            <ClipLoader size={30} color="#fb3973" />
          </div>
        </If>

        <If condition={driver}>
          <DriverInfoContent driver={driver as DriverDetailsData} />
        </If>
      </BoxShadowLayout>
    </ContentLayout>
  );
};

export default DriverInfo;
